export default "https://cdn-static.gokick.com/assets/6909edbc169b94fbe838446b12805066cb856688/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";